export enum FilterPanelEvent {
	FILTER_CHANGED = 'FilterPanel.changed'
}
